import { useStateMethods } from '../providers/stateManager';

export const useRemoveFile = (key) => {
  const { setValue } = useStateMethods();

  return (index) => {
    setValue(key, (value) => {
      return [...value.slice(0, index), ...value.slice(index + 1)];
    });
  };
};
